import React, { useState } from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Row, Col } from "react-bootstrap";
import LeftConvocation from "./LeftConvocation";
import C2025 from "./2025";
import C2024_2 from "./2024_2";
import C2024 from "./2024";
import C2021 from "./2021";
import C2019 from "./2019";


function Main() {
    const [activeIndex, setActiveIndex] = useState(0);
    const getHeading = () => {
        switch (activeIndex) {
            case 0:
                return "Convocation-2025";
            case 1:
                return "Convocation-2024";
            case 2:
                return "Convocation-2024";
            case 3:
                return "Convocation-2021";
            case 4:
                return "Convocation-2019";
                
            default:
                return "Null";
        }
    };

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Past Convocations" />
            <section className="project-detail">
                <div className="container">
                    <div
                        className="section-title center-align mb-50 wow fadeInDown animated"
                        data-animation="fadeInDown"
                        data-delay=".4s"
                    >
                        {/* <h5>
                            <i className="fal fa-graduation-cap" />{" "}
                            Health-Center
                        </h5> */}
                        <h3 class='text-center'><i className="fal fa-graduation-cap" />{" "}{getHeading()}</h3>
                    </div>
                    <Row>
                        <Col md={4} className="c-left mb-25">
                            <LeftConvocation
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                        </Col>
                        <Col md={8} className="c-left">
                            <Row>
                                {activeIndex === 0 && <C2025 />}
                                {activeIndex === 1 && <C2024_2 />}
                                {activeIndex === 2 && <C2024 />}
                                {activeIndex === 3 && <C2021 />}
                                {activeIndex === 4 && <C2019 />}
                  
                            </Row>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
